import { MessageCircle, ClipboardList, Hammer } from 'lucide-react';

export type MessageMode = 'ask' | 'plan' | 'implement';

interface ModeOption {
  value: MessageMode;
  label: string;
  icon: typeof MessageCircle;
  color: string;
  description: string;
}

const MODES: ModeOption[] = [
  {
    value: 'ask',
    label: 'Ask',
    icon: MessageCircle,
    color: 'text-blue-600',
    description: 'Conversa/pergunta — responde direto, sem ler arquivos exploratoriamente',
  },
  {
    value: 'plan',
    label: 'Plan',
    icon: ClipboardList,
    color: 'text-yellow-600',
    description: 'Planejamento read-only — analisa código e propõe um checklist',
  },
  {
    value: 'implement',
    label: 'Implement',
    icon: Hammer,
    color: 'text-green-600',
    description: 'Implementação completa — pode editar, criar arquivos e rodar comandos',
  },
];

interface ModeSelectorProps {
  value: MessageMode;
  onChange: (mode: MessageMode) => void;
  disabled?: boolean;
}

export function ModeSelector({ value, onChange, disabled }: ModeSelectorProps) {
  const current = MODES.find((m) => m.value === value) || MODES[0];

  return (
    <div className="relative">
      <select
        value={value}
        onChange={(e) => onChange(e.target.value as MessageMode)}
        disabled={disabled}
        className="appearance-none input pl-8 pr-7 cursor-pointer disabled:opacity-50"
        title={current.description}
      >
        {MODES.map((m) => (
          <option key={m.value} value={m.value}>
            {m.label}
          </option>
        ))}
      </select>
      <div
        className={`absolute left-2 top-1/2 -translate-y-1/2 pointer-events-none ${current.color}`}
      >
        <current.icon size={14} />
      </div>
      <div className="absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none text-text-muted text-xs">
        ▼
      </div>
    </div>
  );
}
